import { combineReducers } from "redux";
// import globalSetting from "./globalSetting";
import dashboard from "./dashboard";
import logs from "./logs";
import scrollPagination from "./scrollPagination";
import apiUsage from "./apiUsage";
import integrations from "./integrations";
import userInfo from "./userInfo";
import support from "./support";
import { providerReducer } from "./provider";
import { partnerReducer } from "./partner";
import { marketReducer } from "./market";
import { storeReducer } from "./store";
import selectionReducer from "./selectionReducer";
import { auditlogListReducer } from "./auditlogs";
import { headerReducer } from "./header";
import monitor from "./monitor";

const initialAuthState = {
  isAuthenticated: false,
};

// Authentication reducer
const authReducer = (state = initialAuthState, action:any) => {
  switch (action.type) {
    case 'LOGIN':
      return { ...state, isAuthenticated: true };
    case 'LOGOUT':
      return { ...state, isAuthenticated: false };
    default:
      return state;
  }
};

const rootReducer = combineReducers({
  dashboard:dashboard,
  logs:logs,
  scrollPagination: scrollPagination,
  auth: authReducer,
  apiUsage:apiUsage,
  integrations: integrations,
  userInfo,
  support,
  providers:providerReducer,
  partner:partnerReducer,
  market:marketReducer,
  store:storeReducer,
  selection:selectionReducer,
  auditlog:auditlogListReducer,
  header:headerReducer,
  monitor
});

export type RootState = ReturnType<typeof rootReducer>;
export default rootReducer;
